import Axios from "axios";

export function createAxiosInstance() {
  if (typeof window === "undefined") {
    throw new Error("createAxiosInstance must be called in the browser only.");
  }

  const authTokens =
    typeof window !== "undefined" &&
    localStorage &&
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens") as any)
      : null;

  const axiosInstance = Axios.create({
    baseURL: process.env.NEXT_PUBLIC_HOST_API,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${authTokens?.access_token}`,
    },
  });

  axiosInstance.interceptors.request.use((config) => {
    if (typeof window !== "undefined" && localStorage) {
      const token = JSON.parse(localStorage.getItem("authTokens") as any);
      if (config.headers)
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = token
          ? `Bearer ${token.access_token}`
          : "";
    }
    return config;
  });

  // trigger
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error.response &&
        (error.response?.status === 401 ||
          error.response?.data?.message === "Unauthenticated")
      ) {
        if (typeof window !== "undefined" && localStorage) {
          localStorage.removeItem("authTokens");
          window.location.replace("/sign-in");
        }
      }

      throw error;
    },
  );

  return axiosInstance;
}
